import { Link } from "react-router";
import Btn from "@/components/Btn/Btn";
import "./Footer.css";

// -----------------------------------------------------------------------------------

export default function Footer() {
	function scrollToTop() {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}

	const currentYear = new Date().getFullYear();

	// -----------------------------------------------------------------------------------

	return (
		<footer>
			{/* Column 1 */}
			<div className="footer-column">
				<div className="footer-top-half">
					{/* Asimov Press logo */}
					<svg
						role="img"
						aria-labelledby="asimov-press-logo-title"
						width="212"
						height="42"
						viewBox="0 0 180 34"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<title id="asimov-press-logo-title">Asimov Press logo</title>
						<path
							d="M47.1031 25.4944C48.3096 25.3899 49.3071 25.0479 48.5984 23.2904L47.0252 19.3289H40.151L38.6026 23.2904C37.9205 25.0479 38.9712 25.3804 40.1226 25.4944V25.8877H34.9014V25.4944C35.9768 25.3899 36.9913 25.0479 37.6829 23.2904L44.1106 6.99976H45.1594L51.6916 23.2904C52.4003 25.0745 53.2933 25.3804 54.211 25.4944V25.8877H47.1012L47.1031 25.4944ZM40.4664 18.5157H46.7098L43.5615 10.6193L40.4664 18.5157Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M58.9724 26.1292C57.6595 26.1292 55.9552 25.7092 54.1179 24.896L54.1958 21.3279H54.591C55.6132 24.423 57.4239 25.3179 58.9971 25.3179C60.4411 25.3179 61.412 24.5579 61.412 23.2184C61.412 21.6186 59.8369 21.1455 57.8172 20.3323C55.4555 19.3614 54.04 18.4437 54.04 16.5323C54.04 14.1972 55.902 12.6753 58.79 12.6753C60.2717 12.7131 61.7288 13.062 63.0669 13.6994L62.9871 17.0567H62.5672C61.754 14.1972 60.1808 13.4885 58.7672 13.4885C57.2187 13.4885 56.2231 14.3017 56.2231 15.4569C56.2231 16.899 57.8761 17.2657 60.2131 18.2366C62.0238 18.9453 63.5989 19.8116 63.5989 22.0935C63.5913 24.6547 61.6324 26.1292 58.9724 26.1292Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M63.8701 25.5209C65.0234 25.4164 65.9601 25.0744 65.9601 23.2637V15.4471C65.9601 13.6364 65.0101 13.2944 63.8891 13.1899V12.8289H68.6106V23.2695C68.6106 25.0801 69.5606 25.4221 70.7101 25.5266V25.8933H63.8701V25.5209ZM65.1298 9.1809C65.1368 8.71493 65.3284 8.27077 65.6625 7.9459C65.9967 7.62104 66.446 7.44208 66.912 7.44817C67.3783 7.44157 67.8282 7.62033 68.1627 7.94525C68.4973 8.27017 68.6891 8.7146 68.6961 9.1809C68.6954 9.41374 68.6485 9.64416 68.5583 9.8588C68.468 10.0734 68.3362 10.2681 68.1703 10.4315C68.0044 10.5949 67.8078 10.7238 67.5919 10.8108C67.3759 10.8979 67.1448 10.9412 66.912 10.9384C66.4428 10.9389 65.9923 10.7543 65.6586 10.4244C65.3248 10.0946 65.1348 9.64629 65.1298 9.1771V9.1809Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M85.9783 25.521C86.9492 25.4165 87.7358 25.0746 87.7358 23.2639V17.1516C87.7358 15.3162 86.6604 14.503 85.3741 14.503C84.4241 14.503 83.5387 14.9476 82.6989 15.8919C82.7255 16.1807 82.7521 16.4961 82.7521 16.8115V23.2715C82.7521 25.0822 83.5387 25.4241 84.5096 25.5286V25.8954H78.3707V25.5286C79.3416 25.4241 80.1282 25.0822 80.1282 23.2715V17.1592C80.1282 15.3238 79.0775 14.5106 77.7665 14.5106C76.8165 14.5106 75.9824 14.9552 75.1426 15.8995V23.2715C75.1426 25.0822 75.9311 25.4241 76.9799 25.5286V25.8954H70.499V25.5286C71.601 25.4241 72.494 25.0822 72.494 23.2715V15.4549C72.494 13.6442 71.601 13.3022 70.499 13.1977V12.8291H75.1426V15.1908C76.1933 13.5378 77.5043 12.6714 79.1041 12.6714C80.7039 12.6714 82.0947 13.5112 82.5678 15.3219C83.6698 13.5891 85.0378 12.6714 86.687 12.6714C88.6535 12.6714 90.3863 14.0014 90.3863 16.8172V23.2772C90.3863 25.0879 91.2508 25.4299 92.3015 25.5344V25.901H85.9783V25.521Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M98.5056 26.0987C95.1217 26.0987 92.209 23.5014 92.209 19.329C92.209 15.1566 95.1217 12.6658 98.5056 12.6658C101.889 12.6658 104.829 15.1851 104.829 19.329C104.829 23.4729 101.889 26.0987 98.5056 26.0987ZM95.1996 19.329C95.1996 22.2949 96.1705 25.3368 98.5056 25.3368C100.841 25.3368 101.838 22.3196 101.838 19.329C101.838 16.3384 100.814 13.4276 98.5056 13.4276C96.1971 13.4276 95.1996 16.365 95.1996 19.329Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M106.111 15.2991C105.402 13.6195 104.669 13.3041 103.855 13.1996V12.8291H110.315V13.1958C109.162 13.3269 108.453 13.6955 109.109 15.2953L112.073 22.483L114.959 15.2953C115.616 13.6423 114.723 13.3003 113.648 13.1958V12.8291H118.187V13.1958C117.321 13.3003 116.508 13.6423 115.825 15.3219L111.602 25.8878H110.578L106.111 15.2991Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M122.474 25.4944C123.68 25.3899 124.678 25.0232 124.678 23.1327V9.7529C124.678 7.8643 123.68 7.49761 122.474 7.39311V6.99976H131.261C134.936 6.99976 137.506 9.49065 137.506 12.7434C137.506 16.3914 134.466 18.5689 130.737 18.5689H127.588V23.1289C127.588 25.0289 128.613 25.3861 129.792 25.4906V25.8839H122.474V25.4944ZM127.588 17.7291H130.248C132.846 17.7291 134.446 15.4737 134.446 12.7434C134.446 10.0948 132.977 7.83768 130.406 7.83768H127.598L127.588 17.7291Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M137.533 25.5207C138.635 25.4162 139.553 25.0743 139.553 23.2636V15.4469C139.553 13.6362 138.635 13.2943 137.533 13.1898V12.8288H142.23V17.0258C142.832 14.5084 144.852 12.2512 147.449 12.7756L147.056 15.4793H146.866C144.713 14.5863 142.589 16.1613 142.222 19.2032V23.2693C142.222 25.08 143.14 25.422 144.242 25.5265V25.8931H137.525L137.533 25.5207Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M153.488 26.0987C150.366 26.0987 147.533 23.6591 147.533 19.3557C147.533 15.2631 149.946 12.6658 153.332 12.6658C156.794 12.6658 158.709 15.3941 158.682 18.9623H150.322C150.4 22.5571 152.184 24.4458 154.493 24.4458C155.937 24.4458 157.326 23.7636 158.403 22.3728L158.717 22.4508C158.326 23.5228 157.614 24.4484 156.679 25.1012C155.743 25.754 154.629 26.1023 153.488 26.0987ZM150.34 18.2023H155.954C155.876 15.7608 154.958 13.4523 153.252 13.4523C151.417 13.4523 150.473 15.9451 150.34 18.2023Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M164.817 26.1292C163.506 26.1292 161.8 25.7092 159.964 24.896L160.042 21.3279H160.432C161.456 24.423 163.265 25.3179 164.84 25.3179C166.282 25.3179 167.253 24.5579 167.253 23.2184C167.253 21.6186 165.68 21.1455 163.658 20.3323C161.298 19.3614 159.881 18.4437 159.881 16.5323C159.881 14.1972 161.743 12.6753 164.631 12.6753C166.113 12.7128 167.57 13.0618 168.908 13.6994L168.83 17.0567H168.412C167.599 14.1972 166.024 13.4885 164.612 13.4885C163.063 13.4885 162.066 14.3017 162.066 15.4569C162.066 16.899 163.719 17.2657 166.056 18.2366C167.867 18.9453 169.44 19.8116 169.44 22.0935C169.434 24.6547 167.462 26.1292 164.817 26.1292Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M175.374 26.1292C174.061 26.1292 172.357 25.7092 170.519 24.896L170.597 21.3279H170.992C172.015 24.423 173.825 25.3179 175.398 25.3179C176.842 25.3179 177.813 24.5579 177.813 23.2184C177.813 21.6186 176.238 21.1455 174.219 20.3323C171.857 19.3614 170.441 18.4437 170.441 16.5323C170.441 14.1972 172.303 12.6753 175.191 12.6753C176.673 12.7131 178.13 13.062 179.468 13.6994L179.388 17.0567H178.969C178.155 14.1972 176.582 13.4885 175.169 13.4885C173.62 13.4885 172.625 14.3017 172.625 15.4569C172.625 16.899 174.278 17.2657 176.615 18.2366C178.425 18.9453 180 19.8116 180 22.0935C179.991 24.6547 178.022 26.1292 175.374 26.1292Z"
							fill="var(--primary-light)"
						/>
						<path
							d="M22.4922 11.2518C22.4892 8.37895 21.3888 5.61569 19.4159 3.52733C17.4431 1.43898 14.7468 0.183268 11.8788 0.0170703V0H10.6134V0.0170703C7.74531 0.183268 5.04911 1.43898 3.07625 3.52733C1.10338 5.61569 0.00294138 8.37895 0 11.2518V33.1189H0.632691C2.96479 33.1153 5.2383 32.388 7.13939 31.0372C9.04048 29.6864 10.4754 27.7789 11.2461 25.5778C12.018 27.7776 13.4533 29.6838 15.3543 31.0335C17.2553 32.3832 19.5281 33.1097 21.8595 33.1131H22.4922V11.2518ZM21.2268 11.2518C21.2224 13.7878 20.2544 16.2273 18.5187 18.0762C16.783 19.9252 14.4094 21.0453 11.8788 21.2096V1.27869C14.4122 1.44322 16.7882 2.56537 18.5246 4.41749C20.261 6.26962 21.2277 8.71304 21.2287 11.2518H21.2268ZM1.26731 31.8287V11.2518C1.26878 8.71426 2.23567 6.27223 3.97174 4.42148C5.70781 2.57073 8.083 1.44987 10.6153 1.2863V21.8746C10.6096 24.4098 9.64093 26.8482 7.90542 28.6963C6.16991 30.5443 3.79715 31.664 1.26731 31.8287ZM21.2287 31.8287C18.8025 31.6704 16.5171 30.6333 14.8004 28.9116C13.0836 27.1899 12.0531 24.9017 11.9016 22.4751C13.8477 22.3595 15.7303 21.7405 17.3653 20.6787C19.0003 19.6169 20.3315 18.1487 21.2287 16.4179V31.8287Z"
							fill="var(--primary-light)"
						/>
					</svg>

					<p>
						Designed and developed by Dave Belmont from{" "}
						<a
							href="https://dnarna.co/"
							target="_blank"
							rel="noopener noreferrer"
						>
							DNARNA.co
						</a>
						, with{" "}
						<a
							href="https://press.asimov.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							Asimov Press
						</a>{" "}
						and authors of the report.
					</p>
				</div>

				<div className="footer-link-sequence">
				<p>
						<a
							href="https://www.reddit.com/r/brainem"
							target="_blank"
							rel="noopener noreferrer"
						>
							r/brainem 
						</a>{' '}
						on reddit
				</p>

					<span className="square">￭</span>

					<a
						href="https://forms.gle/x3ahCfhurrezDCWR8"
						target="_blank"
						rel="noopener noreferrer"
					>
						Tell us what to improve
					</a>

					<span className="square">￭</span>

					<p>How to cite</p>
				</div>
			</div>

			{/* ------------------------------------------------------------------------------- */}

			<div className="footer-column">
				<div className="footer-top-half">
					<Btn
						label="Scroll to Top"
						className="scroll-btn"
						onClick={scrollToTop}
						icon={
							<svg
								className="scroll-icon"
								xmlns="http://www.w3.org/2000/svg"
								width={15}
								height={15}
								viewBox="0 0 24 24"
								fill="currentColor"
								stroke="currentColor"
								strokeWidth={0.6}
								aria-hidden="true"
							>
								<path d="M13 7.828V20h-2V7.828l-5.364 5.364l-1.414-1.414L12 4l7.778 7.778l-1.414 1.414z" />
							</svg>
						}
						icon2={
							<svg
								className="scroll-icon"
								xmlns="http://www.w3.org/2000/svg"
								width={15}
								height={15}
								viewBox="0 0 24 24"
								fill="currentColor"
								stroke="currentColor"
								strokeWidth={0.6}
								aria-hidden="true"
							>
								<path d="M13 7.828V20h-2V7.828l-5.364 5.364l-1.414-1.414L12 4l7.778 7.778l-1.414 1.414z" />
							</svg>
						}
					/>

					<p>
						Props to{" "}
						<a
							href="https://brain.harvard.edu/?people=andreas-horn"
							target="_blank"
							rel="noopener noreferrer"
						>
							Andreas Horn
						</a>{" "}
						for providing the connectome image, and to{" "}
						<a
							href="https://www.biorender.com/"
							target="_blank"
							rel="noopener noreferrer"
						>
							BioRender
						</a>{" "}
						for organism illustrations.
					</p>
				</div>

				<p>
					<span className="move-up">©</span> {currentYear}{" "}
					<span className="square">￭</span>{" "}
					<Link to="/privacy" className="unstyled-link">
						Privacy Policy
					</Link>{" "}
					<span className="square">￭</span>{" "}
					<Link to="/terms" className="unstyled-link">
						Terms of Service
					</Link>
				</p>
			</div>
		</footer>
	);
}
